"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DataParser {
    constructor() {
    }
    /**
     *
     * @param data input from outside source
     * @returns ParsedOutput[]
     */
    parse(data) {
    }
    /**
     *
     * @param data array of parsed input data
     * @returns FormatOutput[]
     */
    format(data) {
    }
}
exports.default = DataParser;
